import React, { useEffect } from "react";
import { useSelector } from "@adsk/acc-issues-core/state/redux/hooks";
import { getIssueTableSelectedIds } from "@adsk/acc-issues-core/state/redux/ducks/issueTableSelection";
import Button from "@adsk/alloy-react-button";
import { PencilIcon } from "@adsk/alloy-react-icon";
import { getIssuesByIds } from "@adsk/acc-issues-core/state/redux/ducks/issuesCollection";
import { useTranslations } from "@adsk/acc-issues-translations";
import { IssueBulkDeleteButton } from "../../../IssueBulkEditPanel/IssueBulkDeleteButton";
import { useCurrentRightPanel } from "../useCurrentRightPanel";
import { trackBulkEditClickAction } from "../../../utils/analytics/issueActionsTracking";
import { PanelType } from "../PanelType";

export const IssuesTableBulkActionButtons = ({
  onSuccessfulDeletion,
}: {
  onSuccessfulDeletion?: () => void;
}) => {
  const issueUids = useSelector(getIssueTableSelectedIds);
  const issues = useSelector(getIssuesByIds)(issueUids);
  const { T } = useTranslations();
  const { toggleBulkEditPanel, activePanelType } = useCurrentRightPanel();

  const selectedIssuesCount = issueUids.length;

  // close the bulk edit panel if the last selection is removed
  useEffect(() => {
    if (
      selectedIssuesCount === 0 &&
      activePanelType === PanelType.BulkEditPanel
    ) {
      toggleBulkEditPanel();
    }
  }, [selectedIssuesCount, activePanelType, toggleBulkEditPanel]);

  if (selectedIssuesCount < 2) {
    return null;
  }

  return (
    <>
      <div data-testid="bulk-edit-button">
        <Button
          variant={Button.VARIANTS.TERTIARY}
          renderIcon={p => <PencilIcon {...p} />}
          onClick={() => {
            trackBulkEditClickAction();
            toggleBulkEditPanel();
          }}
        >
          {T.translate("issueTable.bulkEdit", {
            selectedCount: selectedIssuesCount,
          })}
        </Button>
      </div>
      <IssueBulkDeleteButton
        issues={issues}
        onSuccessfulDeletion={onSuccessfulDeletion}
      />
    </>
  );
};
